import { useEffect, useCallback, useState } from 'react';

export const useContextMenu = (
  elementRef: React.RefObject<HTMLElement>,
  onShowContextMenu: (event: MouseEvent) => void,
  onHideContextMenu: () => void,
) => {
  const [anchorPoint, setAnchorPoint] = useState({ x: 0, y: 0 });
  const [show, setShow] = useState(false);

  const handleContextMenu = useCallback(
    (event: MouseEvent) => {
      event.preventDefault();
      setAnchorPoint({ x: event.pageX, y: event.pageY });
      setShow(true);
      onShowContextMenu(event);
    },
    [setShow, setAnchorPoint, onShowContextMenu],
  );

  const handleClick = useCallback(() => {
    if (show) {
      setShow(false);
      onHideContextMenu();
    }
  }, [show, onHideContextMenu]);

  const closeContextMenu = useCallback(() => setShow(false), []);

  useEffect(() => {
    const element = elementRef.current;
    if (element) {
      document.addEventListener('click', handleClick);
      element.addEventListener('contextmenu', handleContextMenu);
    }

    return () => {
      if (element) {
        document.removeEventListener('click', handleClick);
        element.removeEventListener('contextmenu', handleContextMenu);
      }
    };
  });

  return { anchorPoint, show, closeContextMenu };
};
